import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

export default function swipersPersonalizados() {
    //SCRIPT LA VOZ DE LOS PROTAGONISTAS
    const swiperLaVozDeLosProtagonistas = new Swiper('.quote-cards-panel_wrp', {
        // Optional parameters
        //loop: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 3000,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        modules: [Pagination],
    });

    //SCRIPT Propuesta Educativa
    const swiper4 = new Swiper('.text-photo-slider-panel_wrp', {
        // Optional parameters
        // loop: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        modules: [Pagination, Navigation],
    });

    // const swiperNoLoop = new Swiper('.text-photo-slider-panel_wrp', {
    //   // Optional parameters
    //   // loop: true,
    //   slidesPerView: 'auto',
    //   spaceBetween: 20,
    //   speed: 1000,
    //   pagination: {
    //     el: '.swiper-pagination',
    //     type: 'bullets',
    //     clickable: true,
    //   },
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    //   modules: [Pagination, Navigation],
    // });

    const swiperm4 = new Swiper('.modulo4_wrp', {
        // Optional parameters
        // loop: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        speed: 1000,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        modules: [Pagination, Navigation],
    });

    const swiperLoop = new Swiper('.text-photo-slider-panel_wrp_loop', {
        // Optional parameters
        loop: true,
        slidesPerView: 3,
        spaceBetween: 20,
        speed: 1000,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
           clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        modules: [Pagination, Navigation],
    });
}
